// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".landing-form{color:rgba(0,0,0,.65)}.landing-form p{margin:0 0 16px;padding:0;line-height:20px}.landing-form-agreement{font-size:12px;line-height:16px}.landing-form-agreement-link{color:#337ab7;text-decoration:none}", ""]);
// Exports
module.exports = exports;
